import IssuuLookupModelBase from '../_generated/modelBases/issuu-lookup-model-base';

export default class IssuuLookupModel extends IssuuLookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
